import React from 'react';
import { DatePicker as MUIDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import useQuestion from './useQuestion';

const DatePicker = (props) => {
    const { question, disabled } = props;

    const { answerText } = useQuestion(question);

    //#TODO TechDebt - This Component has only had a disabled state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MUIDatePicker
                value={!!answerText ? new Date(answerText) : null}
                //#TODO TechDebt
                // onChange={(newVal) => console.log(newVal)}
                disabled={disabled}
            />
        </LocalizationProvider>
    );
};

export default DatePicker;
